import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function EarnRewardsIcon({
    width = 150,
    height = 150,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 300.000000 188.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,188.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M1457 1414 c-4 -4 -7 -43 -7 -86 0 -77 0 -78 25 -78 26 0 26 0 23 82 -2 65 -6 83 -18 86 -9 1 -19 0 -23 -4z" />
                <path d="M1047 1243 c-16 -16 -4 -42 41 -86 52 -51 63 -55 82 -31 11 13 5 23 -41 70 -51 52 -68 62 -82 47z" />
                <path d="M1821 1196 c-46 -47 -52 -57 -41 -70 7 -9 18 -16 24 -16 22 0 108 97 104 116 -6 34 -33 25 -87 -30z" />
                <path d="M1415 1050 l-39 -119 -130 -3 c-123 -3 -131 -4 -131 -23 0 -13 30 -42 95 -88 72 -52 95 -74 94 -91 -1 -11 -16 -67 -35 -124 -24 -77 -30 -105 -21 -114 15 -15 34 -5 142 75 l85 64 70 -51 c39 -27 83 -60 98 -73 33 -27 55 -29 64 -8 3 9 -12 68 -33 132 l-38 116 21 14 c11 8 58 41 103 74 116 85 111 93 -56 97 l-130 3 -39 119 c-33 103 -42 120 -60 120 -18 0 -27 -17 -60 -120z m95 -100 l25 -75 93 0 c50 0 92 -2 92 -5 -1 -3 -26 -21 -56 -40 -100 -63 -98 -57 -64 -152 16 -46 27 -84 25 -86 -2 -3 -32 17 -67 43 -35 26 -69 50 -75 52 -7 3 -45 -18 -83 -47 -39 -29 -73 -51 -75 -48 -2 2 9 38 25 80 17 42 28 83 25 90 -3 7 -37 33 -75 58 -38 25 -69 47 -69 50 -1 3 41 5 92 5 l92 0 29 90 c16 50 32 83 35 75 3 -8 17 -49 31 -90z" />
                <path d="M878 839 c-5 -4 -8 -15 -6 -25 3 -16 14 -19 81 -22 64 -2 78 0 83 13 4 9 1 22 -5 28 -12 12 -135 17 -153 6z" />
                <path d="M1918 833 c-5 -7 -8 -20 -4 -28 5 -13 20 -15 83 -13 72 3 78 5 81 26 2 12 0 22 -5 23 -78 6 -146 3 -155 -8z" />
                <path d="M1087 472 c-49 -49 -59 -78 -31 -89 11 -4 34 12 72 50 47 48 54 58 43 71 -21 25 -33 20 -84 -32z" />
                <path d="M1779 504 c-11 -13 -4 -23 43 -71 38 -38 61 -54 72 -50 28 11 17 41 -32 90 -52 51 -63 55 -83 31z" />
                <path d="M1461 381 c-8 -5 -11 -33 -9 -87 3 -71 5 -79 23 -79 18 0 20 8 23 81 3 83 -6 104 -37 85z" />
            </g>
        </svg>
    )
}
